/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".checked[_ngcontent-%COMP%]{box-shadow:0 4px 15px 0 rgba(0,0,0,.2)}.active[_ngcontent-%COMP%]{font-weight:700}.text[_ngcontent-%COMP%]{order:2}.checkbox[_ngcontent-%COMP%]{order:3;margin-left:5px;cursor:pointer}.checkbox.inverted[_ngcontent-%COMP%]{margin-right:5px;order:1}"];
export { styles as styles };
